import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var trackEvent = function trackEvent(eventName, location) {
  var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (typeof analytics !== 'undefined') {
    var eventProps = _objectSpread({
      location: location
    }, properties);
    var proposalContainer = document.getElementById('show-container-with-data');
    if (proposalContainer) {
      Object.assign(eventProps, {
        consultantEmail: proposalContainer.dataset.consultantEmail,
        projectName: proposalContainer.dataset.projectName
      });
    }
    analytics.track(eventName, eventProps);
  }
};
document.addEventListener('DOMContentLoaded', function () {
  // Helper to add click tracking
  var trackClick = function trackClick(selector, eventName, location, propsOrFn) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.addEventListener('click', function () {
        var props = typeof propsOrFn === 'function' ? propsOrFn(el) : propsOrFn;
        trackEvent(eventName, location, props);
      });
    });
  };

  // NavBar
  trackClick('#nav-item-start-project', 'Clicked on Add Project', 'Nav Bar');
  trackClick('#sign-out', 'Clicked on Sign Out', 'Nav Bar');
  trackClick('#intercom-launcher', 'Clicked on Intercom Button', 'Always There');
  trackClick('#navbar-top-consultants', 'Clicked on Top-tier Consultants', 'Nav Bar');
  trackClick('#navbar-search', 'Clicked on search button', 'Nav Bar');
  trackClick('#account-settings-button', 'Clicks Account Settings in Dropdown', 'Nav Bar');

  // Landing Page
  trackClick('#for-consultants', 'Clicked on For Consultants', 'Landing - NavBar');
  trackClick('#for-employers', 'Clicked on For Employers', 'Landing - NavBar');
  trackClick('#sign-in', 'Clicked on Sign In', 'Landing - NavBar');
  trackClick('#i-am-an-employer', 'Clicked on I am an Employer', 'Landing');
  trackClick('#i-am-a-consultant', 'Clicked on I am a Consultant', 'Landing');
  trackClick('#find-your-consultant', 'Clicked on Find Your Consultant', 'Landing');
  trackClick('#privacy-policy', 'Clicked on Privacy Policy', 'Landing');

  // Employer Sign-Up
  trackClick('#employer-sign-up-registration', 'Clicked on Sign Up', 'Employer Sign Up - Registration Page');
  trackClick('#employer-sign-up-project-feedback', 'Clicked on Sign Up', 'Employer Sign Up - Project Feedback Page');
  trackClick('#employer-sign-up-proposal-feedback', 'Clicked on Sign Up', 'Employer Sign Up - Proposal Feedback Page');

  // Sign-In
  trackClick('#sign-in-project-feedback', 'Clicked on Sign In', 'Project Feedback Page');
  trackClick('#sign-in-proposal-feedback', 'Clicked on Sign In', 'Proposal Feedback Page');

  // Employer Phone number
  trackClick('#phone-number-save-n-continue', 'Save Phone Number', 'Save and Continue');
  trackClick('#phone-number-complete-later', 'Save Phone Number', 'Complete Later');

  // Employer Onboarding
  trackClick('.how-clora-works-page-1-btn', 'Clicked on Learn how Clora works', 'How Clora Works For Employer Modal');
  trackClick('.how-clora-works-page-2-btn', 'Clicked on Get Started', 'How Clora Works For Employer Modal');
  trackClick('.how-clora-works-request-demo', 'Clicked on Request Demo', 'How Clora Works For Employer Modal');
  trackClick('.how-clora-works-add-project', 'Clicked on Add Project', 'How Clora Works For Employer Modal');
  trackClick('.project-lead-send-answers', 'Sent Project Lead Answers', 'Project Leads Modal');
  trackClick('#project-lead-request-demo', 'Clicked on Request Demo', 'Projects Index View');
  trackClick('#add-project-welcome', 'Clicked on Add Project', 'Projects Index View');
  trackClick('.how-clora-works-top-consultants', 'Clicked on Browse Top Consultants', 'How Clora Works For Employer Modal');

  // Project View
  trackClick('#share-project', 'Clicked on Share Project', 'Project View');
  trackClick('#delete-project', 'Clicked on Delete', 'Project View');
  trackClick('#edit-project', 'Clicked on Edit', 'Project View');
  trackClick('#publish-project', 'Clicked on Publish', 'Project View');
  trackClick('#unpublish-project', 'Clicked on Unpublish', 'Project View');
  trackClick('#referral-from-published-project', 'Clicked on Referral Program', 'Project Published Modal');
  trackClick('.review-btn', 'Employer reviews proposal', 'Project View');
  trackClick('.view-resume-btn', 'Employer views resume from project-show-view', 'Project View');
  trackClick('.view-proposal-project-show', 'Consultant clicks Views Proposal from Project Show Page', 'Project View');
  trackClick('.finish-proposal-project-show', 'Consultant clicks Finish Proposal from Project Show Page', 'Project View');
  trackClick('#edit-project-status-button', 'Employer clicks Edit Project button', 'Project View');
  trackClick('#retract-project-status-button', 'Employer clicks Retract Submission button', 'Project View');
  trackClick('.duplicate', 'Created Duplicate Project', 'Project View');

  // Project Form
  trackClick('.clf-proceed-btn', 'Exit project without saving', 'Project Form');
  trackClick('#save-n-finish-general-info', 'Clicked on Save and Finish', 'Project Form -> General Info Tab');
  trackClick('#save-n-next-general-info', 'Clicked on Save and Next', 'Project Form -> General Info Tab');
  trackClick('#previous-logistics', 'Clicked on Previous', 'Project Form -> Logistics Tab');
  trackClick('#save-n-finish-logistics', 'Clicked on Save and Finish', 'Project Form -> Logistics Tab');
  trackClick('#save-n-next-logistics', 'Clicked on Save and Next', 'Project Form -> Logistics Tab');
  trackClick('#save-n-review', 'Clicked on Save and Review', 'Project Form -> Additional Info Tab');
  trackClick('#previous-additional_info', 'Clicked on Previous', 'Project Form -> Additional Info Tab');

  // Dashboard
  trackClick('a.project-show', 'Clicked on a Project', 'Dashboard with projects');
  trackClick('a.admin-project-show', 'Clicked on a Project', 'Admin dashboard with projects');
  trackClick('a.employer-project-show', 'Clicked on a Project', 'Employer dashboard', function (el) {
    return {
      projectStatus: el.dataset.status
    };
  });
  trackClick('a.add-project-empty', 'Clicked on Add Project', 'Employer dashboard', function (el) {
    return {
      projectStatus: el.dataset.status
    };
  });
  trackClick('#refer-trigger-modal-EmployerDashboard-button', 'Clicked on Refer Now', 'Employer dashboard');

  // Consultant Sign-Up
  trackClick('#consultant-sign-up', 'Clicked on Sign Up', 'Consultant Sign Up');

  // Share Modals
  trackClick('#send-email-share-project', 'Shared Project by Email', 'Share project modal');
  trackClick('#copy-link-share-project', 'Clicked on Copy link', 'Share project modal');
  trackClick('#send-email-share-proposal', 'Share Proposal by Email', 'Share proposal modal');
  trackClick('#copy-link-share-proposal', 'Clicked on Copy link', 'Share proposal modal');

  // Opportunities
  document.querySelectorAll('#opportunity-interested').forEach(function (el) {
    el.addEventListener('click', function () {
      return trackEvent('Clicked "Im Interested" on opportunity', 'Open Opportunities View', {
        project: el.name
      });
    });
  });
  trackClick('.opportunities-nav', 'Clicked on Opportunities', 'NavBar');
  trackClick('.upcoming-opportunity-notification-toggle', 'Toggle upcoming opportunity notification', 'Project Show');
  trackClick('.upcoming-opportunity-read-more', 'Clicked Read More about upcoming opportunity', 'Project Show');
  trackClick('input#upload_resume_button', 'Clicked on Submit Button for Interest', 'Project View');
  trackClick('#interest-tooltip', 'Clicked on Start Your Application tooltip', 'Project View');
  trackClick('#consultant-interest-application-button', 'Clicked on Start Application button', 'Project View');
  trackClick('.application-add-expertise', 'Clicked on Add Expertise during application', 'Project View');
  trackClick('#consultant-interest-application-confirm', 'Clicked on Submit application', 'Project View');
  trackClick('#view-consultant-interest-application', 'Clicked on View Application button', 'Project View');
  trackClick('#consultant-interest-modal-close', 'Clicked on X button in Consultant Interest Modal', 'Project View');
  trackClick('#close-interest-form', 'Clicked on Close button in Consultant Interest Modal', 'Project View');
  trackClick('.consultant-create-proposal-consultant-applications', 'Clicked on Create Proposal', 'Project View');
  trackClick('#refer-trigger-modal-OpenOpportunitiesView-button', 'Clicked on Refer Now', 'Open Opportunities View');
  trackClick('#opportunity-refer-a-friend', 'Clicked on Refer a Friend button on Opportunity', 'Open Opportunities View');

  // Reviews
  trackClick('#review-cancel-changes', 'Canceled review changes', 'User Review View');
  trackClick('#review-save-changes', 'Saved review changes', 'User Review View');
  trackClick('#review-save-feedback', 'Clicked on Save Feedback on Review page', 'User Review View');
  trackClick('#review-edit-review', 'Clicked button to go to edit page', 'User Review View');
  trackClick('#review-single-alert', 'Clicked button to go to review show', 'Review Index');
  trackClick('#review-employer-alert', 'Clicked button to go to review index', 'Employer Dashboard');
  trackClick('.project-dashboard-review-consultant-btn', 'Clicked button to go to review new', 'Employer Dashboard');
  trackClick('.view-review-btn', 'Clicked button to go to review show', 'Project View');
  trackClick('.new-review-btn', 'Clicked button to go to review new', 'Project View');

  // Project Share
  trackClick('#project-share-apply-button', 'Clicked on Apply Now', 'Project share link');
  trackClick('#lower-project-share-apply-button', 'Clicked on Apply Now', 'Project share link - Mobile view lower button');
  trackClick('.not-interested-project-share', 'Clicked on Not Interested', 'Project share link');

  // Proposal Editing/Creation
  trackClick('#create-proposal-continue-tab-0', 'Clicked Save and Continue', 'Create Proposal - Responsibilities Tab');
  trackClick('#create-proposal-continue-tab-1', 'Clicked Save and Continue', 'Create Proposal - Experience Tab');
  trackClick('#create-proposal-continue-tab-2', 'Clicked Save and Continue', 'Create Proposal - Certifications Tab');
  trackClick('#create-proposal-review-tab-3', 'Clicked Save and Review', 'Create Proposal - Logistics Tab');
  trackClick('#create-proposal-back-tab-1', 'Clicked Save and Back', 'Create Proposal - Experience Tab');
  trackClick('#create-proposal-back-tab-2', 'Clicked Save and Back', 'Create Proposal - Certifications Tab');
  trackClick('#create-proposal-back-tab-3', 'Clicked Save and Back', 'Create Proposal - Logistics Tab');
  trackClick('#save-and-continue-later', 'Clicked Save and Review', 'Create Proposal');
  trackClick('#create-proposal-tab-0', 'Clicked Responsibilities Tab', 'Create Proposal');
  trackClick('#create-proposal-tab-1', 'Clicked Experience', 'Create Proposal');
  trackClick('#create-proposal-tab-2', 'Clicked Certifications', 'Create Proposal');
  trackClick('#create-proposal-tab-3', 'Clicked Logistics', 'Create Proposal');
  trackClick('#confirm-submit-proposal-modal-confirm', 'Confirmed Submit Proposal', 'Proposal Page');

  // Invite Colleague
  trackClick('.invite-trigger-project', 'Clicked on Invite Colleague', 'Project View - Invite Colleague Modal');
  trackClick('#add-email-project', 'Clicked on Add Email', 'Project View - Invite Colleague by Email');
  trackClick('.select-colleague-project.grey', 'Clicked on Add Colleague', 'Project View - Invite Colleague by Colleague Record');
  trackClick('.select-colleague-project.green', 'Clicked on Remove Colleague', 'Project View - Invite Colleague by Colleague Record');
  trackClick('.invite-trigger-proposal', 'Clicked on Invite Colleague', 'Proposal View - Invite Colleague Modal');
  trackClick('#add-email-proposal', 'Clicked on Add Email', 'Proposal View - Invite Colleague by Email');
  trackClick('.select-colleague-proposal.grey', 'Clicked on Add Colleague', 'Proposal View - Invite Colleague by Colleague Record');
  trackClick('.select-colleague-proposal.green', 'Clicked on Remove Colleague', 'Proposal View - Invite Colleague by Colleague Record');

  // Feedback
  trackClick('.add-project-comment', 'Clicked on Submit Project Comment', 'Project Show - Add Comment');
  trackClick('.update-project-comment', 'Update Comment', 'Project Show - Update Comment');
  trackClick('textarea.owner-comment', 'Clicked on message for your colleague', 'Project Show - Invite Colleague');
  trackClick('#add-feedback', 'Clicked on Add Feedback', 'Proposal Share - Add Feedback -> Employer Sign Up');
  trackClick('.submit-feedback', 'Submit Feedback', 'Proposal Share - Submit Feedback');
  trackClick('.update-feedback', 'Update Feedback', 'Proposal Share - Update Feedback');
  trackClick('.cancel-edit-feedback', 'Cancel Update Feedback', 'Proposal Share - Cancel Update Feedback');
  trackClick('.edit-proposal-feedback', 'Clicked to Edit Feedback', 'Proposal Share - Edit Feedback');

  // Proposal View
  trackClick('#share-proposal', 'Clicked on Share Proposal', 'Proposal View');
  trackClick('.view-resume', 'Employer views resume on proposal-show-view', 'Proposal View');
  trackClick('#decline-for-employer', 'Decline proposal for employer', 'Proposal View');
  trackClick('#get-interview-in-progress-for-employer', 'Clicked Schedule Interview for employer', 'Proposal View');
  trackClick('#accept-proposal-for-employer', 'Clicked accept proposal for employer', 'Proposal View');

  // Proposal Action Modals
  trackClick('#decline-proposal-modal-button', 'Employer clicks Decline', 'Proposal Action Modal');
  trackClick('#decline-proposal-modal-close', 'Employer cancels Decline', 'Proposal Action Modal');
  trackClick('#decline-proposal-modal-confirm', 'Employer confirms Decline', 'Proposal Action Modal');
  trackClick('#get-interview-in-progress-modal-button', 'Employer clicks Schedule Interview', 'Proposal Action Modal');
  trackClick('#get-interview-in-progress-modal-close', 'Employer cancels Schedule Interview', 'Proposal Action Modal');
  trackClick('#get-interview-in-progress-modal-confirm', 'Employer confirms Schedule Interview', 'Proposal Action Modal');
  trackClick('#accept-proposal-modal-button', 'Employer clicks Accept Proposal', 'Proposal Action Modal');
  trackClick('#accept-proposal-modal-close', 'Employer cancels Accept Proposal', 'Proposal Action Modal');
  trackClick('#accept-proposal-modal-confirm', 'Employer confirms Accept Proposal', 'Proposal Action Modal');

  // Proposal Past Roles
  trackClick('.edit-proposal-past-roles', 'Clicks Edit Proposal Past Roles', 'Proposal Show');
  trackClick('.add-proposal-past-roles', 'Clicks Add Proposal Past Roles', 'Proposal Show');

  // Consultant Profile
  trackClick('#profile-page-edit-button', 'Clicks Edit Profile in top-right', 'Consultant Profile Page');
  trackClick('#profile-page-public-view-button', 'Clicks Employer View in Dropdown', 'Consultant Profile Page');
  trackClick('#profile-page-private-view-button', 'Close Employer View', 'Consultant Profile Page');
  trackClick('.profile-add-past-role-title', 'Clicked Past Role Title', 'Consultant Profile Page');
  trackClick('.profile-add-past-role-department', 'Clicked Past Role Department', 'Consultant Profile Page');
  trackClick('.profile-add-past-role-company-name', 'Clicked Past Role Company Name', 'Consultant Profile Page');
  trackClick('.profile-add-past-role-start-month', 'Clicked Past Role Start Month', 'Consultant Profile Page');
  trackClick('.profile-add-past-role-start-year', 'Clicked Past Role Start Year', 'Consultant Profile Page');
  trackClick('.profile-add-past-role-end-month', 'Clicked Past Role End Month', 'Consultant Profile Page');
  trackClick('.profile-add-past-role-end-year', 'Clicked Past Role End Year', 'Consultant Profile Page');
  trackClick('.profile-add-past-role-current', 'Clicked Past Role Current Checkbox', 'Consultant Profile Page');
  trackClick('#add-past-role', 'Clicked Add another role', 'Consultant Profile Page');

  // Onboarding
  trackClick('#claim-your-info-skip-profile-setting-link', 'Clicked on Skip Profile Setting', 'Onboarding Flow');
  trackClick('.onboard-continue-clora-profile-setting', 'Clicked on Continue Clora Profile Setting', 'Onboarding Flow');
  trackClick('.did-not-claim-1', 'Clicked on Do Not Claim Info', 'Onboarding Flow', {
    info: 'experiences'
  });
  trackClick('.did-not-claim-2', 'Clicked on Do Not Claim Info', 'Onboarding Flow', {
    info: 'roles'
  });
  trackClick('.claim-info-1', 'Clicked on Claim Info', 'Onboarding Flow', {
    info: 'experiences'
  });
  trackClick('.claim-info-2', 'Clicked on Claim Info', 'Onboarding Flow', {
    info: 'roles'
  });
  trackClick('#onboard-consultant-sign-up', 'Clicked on Set Password', 'Onboarding Flow');
  trackClick('.onboard-continue-without-pw', 'Clicked on Continue Without Password', 'Onboarding Flow');
  trackClick('.lazy_onboard-continue-clora-profile-setting', 'Clicked on Continue Clora Profile Setting', 'Lazy Onboarding Flow');
  trackClick('#lazy_onboard-consultant-sign-up', 'Clicked on Set Password', 'Lazy Onboarding Flow');
  trackClick('.lazy_onboard-continue-without-pw', 'Clicked on Continue Without Password', 'Onboarding Flow');

  // Password Reset
  trackClick('#reset-password-button', 'Clicked on Reset Password button', 'Forgot Password Flow - Form Submittal');

  // Referrals
  trackClick('.employer-referral-program', 'Clicked on Referral Program link', 'Employer Referral Program');
  trackClick('#employer-referral-terms', 'Clicked on Read referral terms', 'Employer Referral Program');
  trackClick('.employer-send-referral-reminder', 'Clicked on Send reminder referral email', 'Employer Referral Program');
  trackClick('.consultant-referral-program', 'Clicked on Referral Program link', 'Consultant Referral Program');
  trackClick('#consultant-referral-terms', 'Clicked on Read referral terms', 'Consultant Referral Program');
  trackClick('.consultant-send-referral-reminder', 'Clicked on Send reminder referral email', 'Consultant Referral Program');
  trackClick('#consultant-create-recommendations', 'Clicked on Send Invites', 'Consultant Referral Program');
  trackClick('#recommendation-sign-in', 'Clicked on Sign In link', 'Consultant Referral Program');
  trackClick('#recommendation-sign-up', 'Clicked on Sign Up link', 'Consultant Referral Program');
  trackClick('#consultant-sign-in', 'Completed Sign In form', 'Consultant Referral Program');
  trackClick('#consultant-referral-banner-shares-show', 'Clicked on Referral banner', 'Consultant Referral Program - Project Share');
  trackClick('#consultant-referral-banner-projects-show', 'Clicked on Referral banner', 'Consultant Referral Program - Open Opp');

  // Consultant Interests
  trackClick('#no-projects-view-open-opportunities', 'Clicked on View Open Opportunties', 'Consultant Projects - No Projects');
  trackClick('.accept-resume-button', 'Clicked on Accept button', 'Consultant Interests - Clora Rep Management');
  trackClick('#reject-resume-button', 'Clicked on Reject button', 'Consultant Interests - Clora Rep Management');
  trackClick('#sendEmail-Yes', 'Selected the "Yes" radio button to send the rejection email', 'Consultant Interests - Clora Rep Management');
  trackClick('#sendEmail-No', 'Clicked on No radio button to NOT send rejection email', 'Consultant Interests - Clora Rep Management');
  trackClick('#reject-resume-confirm', 'Clicked on Reject button in modal to reject Interest', 'Consultant Interests - Clora Rep Management');
  trackClick('#reject-resume-close', 'Clicked on Close button to close rejection modal', 'Consultant Interests - Clora Rep Management');

  // Applications
  trackClick('.my-applications-nav', 'Clicked on My Applications', 'NavBar');
  trackClick('#proposal-explanation', "Clicked on What's a proposal?", 'Consultant Applications');
  trackClick('.view-project-my-apps', 'Clicked on View Project', 'Consultant Applications');
  trackClick('.view-proposal-my-apps', 'Clicked on View Proposal', 'Consultant Applications');
  trackClick('.edit-proposal-my-apps', 'Clicked on Edit Proposal', 'Consultant Applications');
  trackClick('.finish-proposal-my-apps', 'Clicked on Finish Proposal', 'Consultant Applications');

  // Team Projects
  trackClick('a.team-projects', 'Clicked on Team Projects link', 'Team Projects');
  trackClick('a.add-feedback', 'Clicked on Add Feedback', 'Team Projects');
  trackClick('a.view-feedback', 'Clicked on View Feedback', 'Team Projects');
  trackClick('a.add-comment', 'Clicked on Add Comment', 'Team Projects');
  trackClick('a.view-comments', 'Clicked on View Comments', 'Team Projects');
  trackClick('a.team-project-project-link', 'Clicked on Project Link', 'Team Projects');
  trackClick('a.team-project-proposal-link', 'Clicked on Proposal Link', 'Team Projects');
  trackClick('a.learn-more-proposal-feedback', 'Clicked on Learn More About Proposal Feedback', 'Team Projects');
  trackClick('a.learn-more-project-feedback', 'Clicked on Learn More About Project Feedback', 'Team Projects');

  // Featured Profiles
  trackClick('#select2-aoe-container', 'Clicked on Functional Area filter', 'Featured Consultants');
  trackClick('#select2-ta-container', 'Clicked on Therapeutic Area filter', 'Featured Consultants');
  trackClick('#select2-therapy-container', 'Clicked on Therapy filter', 'Featured Consultants');
  trackClick('#select2-region-container', 'Clicked on Region filter', 'Featured Consultants');
  trackClick('#featured-profiles-clear-filter', 'Clicked on Clear Filter', 'Featured Consultants');
  trackClick('#featured-page-add-project', 'Clicked on Add Project', 'Featured Consultants');

  // Invoice
  trackClick('#invoice-walkthrough-button', 'Clicked to open Invoice walkthrough', 'Invoices Index');
  trackClick('.view-invoices', 'Clicked on View Invoices', 'Invoices Index');
  trackClick('.create-invoice-invoices-index', 'Clicked on Create Invoice', 'Invoices Index');
  trackClick('.view-invoice', 'Clicked on View invoice', 'Invoices Index');
  trackClick('.edit-invoice', 'Clicked on Edit invoice', 'Invoices Index');
  trackClick('.create-invoice-project-invoices', 'Clicked on Create Invoice', 'Projects#invoices');
  trackClick('.edit-invoice-project-invoices', 'Clicked on Edit invoice', 'Projects#invoices');
  trackClick('.view-invoice-project-invoices', 'Clicked on View invoice', 'Projects#invoices');
  trackClick('.export-pdf-project-invoices', 'Clicked on Export invoice', 'Projects#invoices');
  trackClick('.export-invoice-Invoice.Show', 'Clicked on Export invoice', 'Invoices Show');
  trackClick('.export-invoice-Invoice.Edit', 'Clicked on Export invoice', 'Invoices Edit');
  trackClick('.edit-invoice-on-show', 'Clicked on button to redirect to edit invoice page', 'Invoices Show');
  trackClick('.invoice-request-edit-redirect', 'Clicked on Request Edit button to redirect to request edit invoice', 'Invoices Show');
  trackClick('#approve-invoice-button', 'Clicked on Approve button to open up approve confirmation modal', 'Invoices Show');
  trackClick('#approve-invoice-close', 'Cancelled approving invoice on confirmation modal', 'Invoices Show');
  trackClick('#approve-invoice-confirm', 'Confirmed approve invoice on confirmation modal', 'Invoices Show');
  trackClick('.invoice-cancel-request-edit', 'Cancelled request edits', 'Invoices Edit');
  trackClick('.invite-trigger-project-invoices', 'Clicked link to open Invite Approvers Modal', 'Projects#invoices');
  trackClick('#invoice-walkthrough-link', 'Clicked on Read How It Works Here', 'Employer Invoices Index');
  trackClick('#employer-single-timesheet', 'Clicked on this month timesheet', 'Employer Invoices Index');
  trackClick('#employer-all-timesheets', 'Clicked on All Timesheets', 'Employer Invoices Index');

  // Search
  trackClick('#marketplace-search-btn', 'User clicked search button', 'Search Index');
  trackClick('#contact-support-modal-button', 'Click Contact Sales button on search banner', 'Search Index');
  trackClick('.get-connected.search-get-connected', 'Click Request Proposal on Profile Card', 'Search Index');
  trackClick('.get-connected.profile-get-connected', 'Clicked Request Proposal on the Profile View', 'Consultant Profile Page');
  trackClick('.apply-filters', 'Clicked button to search consultants', 'Search Index');
});